export default {
    meta: {
        title: '广告位编辑',
        isEdit: true,
        isShowNav: true,
        activeMenu: '/advertisement',
        crumbs: {
            path: ['/advertisement'],
            name: ['广告位管理'],
        },
    },
};
